import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  Table,
  Collapse,
  Card,
  CardBody,
} from "reactstrap";
//react router dom
import { useLocation } from "react-router-dom";
// select
import Select from "react-select";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// Componentes
import DeleteButton from "../../../components/Buttons/DeleteButton";
import CompositonModals from "./Session/CompositionModals";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// mascara
import { inputMask } from "../../../utils/helpers/masks/masks";
// validações
import { cpfValidator } from "../../../utils/helpers/masks/validations";
// telefone
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { paisesPt } from "../../../utils/helpers/data/countries";
//service
import { updateParticipantV2 } from "../../../utils/services/participants";
import { getGroups } from "../../../utils/services/group";
import { addLoginInNotificationsScheduled } from "../../../utils/services/notification";
import { getQuotasByLogin, updateQuotas } from "../../../utils/services/quotas";
import { getStatusRsvp } from "../../../utils/services/statusRsvp";

function EditParticipant(props) {
  const { isOpen, toggle } = props;
  const location = useLocation();
  // state de dados do formulário
  const [email] = useState(props?.participant?.email);
  const [nome, setNome] = useState(props?.participant?.nome);
  const [titleQrCode, setTitleQrCode] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.titleQrCode,
  );
  const [codeQrCode, setCodeQrCode] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.codeQrCode,
  );
  const [infoAcess, setInfoAccess] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.infoAcess,
  );
  const [cpf, setCpf] = useState("");
  const [phone, setPhone] = useState(props?.participant?.telefone || "");
  const [company, setCompany] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.empresa,
  );
  const [office, setOffice] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.cargo,
  );
  const [code1, setCode1] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.codigoInterno1,
  );
  const [code2, setCode2] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.codigoInterno2,
  );
  const [code3, setCode3] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.codigoInterno3,
  );
  const [chat, setChat] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.interesseChat,
  );

  const [restricaoHospedagem, setRestricaoHospedagem] = useState(
    props.participant.eventos.filter((e) => e.event.id === props.idEvent)[0]
      ?.restricaoHospedagem,
  );

  // state do Status RSVP (só carregado quando o produto RSVP está habilitado)
  const [statusRsvpList, setStatusRsvpList] = useState([]);
  const [statusRsvpSelected, setStatusRsvpSelected] = useState(null);

  // state de modais de sessão
  const [showModalNewSession, setShowModalNewSession] = useState(false);
  const [showModalEditSession, setShowModalEditSession] = useState(false);
  const [showModalDeleteSession, setShowModalDeleteSession] = useState(false);

  // state de sessões
  const [sessionItem, setSessionItem] = useState("");
  const [sessions, setSessions] = useState([]);
  const [sessionsSource, setSessionsSource] = useState([]);
  //confirmação
  const [success_dlg, setsuccess_dlg] = useState(false);
  // enviar email
  const [sendEmail, setSendEmail] = useState(false);
  //state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  //state de grupos selecionados
  const [groupsMulti, setGroupsMulti] = useState([]);
  // state de erros
  const [nameError, setNameError] = useState("");
  const [cpfError, setCpfError] = useState("");
  const [foneError, setFoneError] = useState("");

  const [sectionError, setSectionError] = useState("");
  const [isOpenSession, setIsOpenSession] = useState(true);

  // validações
  const [updateNotification, setUpdateNotification] = useState(false);
  const [propsModals, setPropModals] = useState({});
  const [isLoading, setIsloading] = useState(false);

  // aplica máscara de CPF ao valor digitado
  const handleChange = (value) => {
    inputMask({ mask: "cpf", value, setMaskedValue: setCpf });
  };

  // formata data ISO (YYYY-MM-DDT...) para DD/MM/YYYY
  const formatDate = (date) => {
    return date.split("T")[0].split("-").reverse().join("/");
  };

  useEffect(() => {
    if (props.participant.cpf) {
      handleChange(props.participant.cpf);
    }
  }, []);

  // adiciona sessão à lista local
  const addSession = (data) => setSessions((prev) => [...prev, data]);

  // atualiza dados de uma sessão na lista local pelo sessionId
  const updateSession = (id, newData) => {
    setSessions((prev) => {
      return prev.map((session) => {
        if (session.sessionId === id) {
          return { ...session, ...newData };
        }
        return session;
      });
    });
  };

  // remove uma sessão da lista local pelo sessionId
  const deleteSession = (sessionIdToDelete) => {
    setSessions((prev) => {
      return prev.filter((session) => session.sessionId !== sessionIdToDelete);
    });
  };

  // alterna visibilidade do collapse de sessões
  const toggleSession = () => setIsOpenSession(!isOpenSession);

  // alterna modal de nova sessão
  function toggleModalNewSession() {
    setShowModalNewSession(!showModalNewSession);
  }

  // alterna modal de edição de sessão
  function toggleModalEditSession() {
    setShowModalEditSession(!showModalEditSession);
  }

  // alterna modal de exclusão de sessão
  function toggleModalDeleteSession() {
    setShowModalDeleteSession(!showModalDeleteSession);
  }

  // verifica se deve exibir os campos CPF e telefone conforme os produtos do evento
  function showCpfAndFone() {
    if (!location.state || !location.state.event?.product) return false;

    const products = location.state.event.product;

    const hasOtherProducts = products.some(
      (p) => p.name !== "Distribuição de Cotas",
    );

    return hasOtherProducts;
  }

  // sincroniza as props dos modais de sessão sempre que seus estados mudam
  function setPropsModals() {
    setPropModals({
      showModalNewSession,
      showModalEditSession,
      showModalDeleteSession,
      toggleModalNewSession,
      toggleModalEditSession,
      toggleModalDeleteSession,
      sessionItem,
      sessionsSource,
      addSession,
      updateSession,
      deleteSession,
      sessions,
    });
  }

  // trata seleção múltipla de grupos, forçando "todos" quando selecionado
  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  // valida os campos e envia o formulário de edição do participante
  async function submitForm(sendEmail) {
    if (!nome) {
      setNameError("O campo Nome é obrigatório.");
      return;
    } else setNameError("");
    if (checkProductExists("Distribuição de Cotas") && sessions.length < 1) {
      setSectionError("O campo Sessão é obrigatório");
      return;
    } else setSectionError("");
    if (
      cpf.replace(/[^\d]+/g, "").length > 0 &&
      cpf.replace(/[^\d]+/g, "").length < 11
    ) {
      setCpfError("Insira todos os dígitos do CPF");
      return;
    } else setCpfError("");

    if (cpf.replace(/[^\d]+/g, "").length === 11 && !cpfValidator(cpf)) {
      setCpfError("Digite um CPF válido");
      return;
    } else setCpfError("");

    if (phone.slice(0, 3) === "+55") {
      const onlyNumbers = phone.replace(/\D+/g, "");

      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setFoneError(
          "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        );
        return;
      } else setFoneError("");
    } else setFoneError("");

    var groupsArray = [];

    if (allGroups) {
      groups.map((e) => groupsArray.push({ id: e.id }));
    } else {
      groupsMulti.map((e) => groupsArray.push({ id: e.value }));
    }

    const form = {
      email: email,
      nome: nome,
      foto: props?.participant?.foto || "",
      titleQrCode: titleQrCode,
      codeQrCode: codeQrCode,
      infoAcess: infoAcess,
      idEvento: props.idEvent,
      grupos: groupsArray, // OR Empty []
      empresa: company,
      cpf: cpf.replace(/[^\d]+/g, ""),
      telefone: phone,
      cargo: office,
      interesseChat: chat,
      codigoInterno1: code1,
      codigoInterno2: code2,
      codigoInterno3: code3,
      restricaoHospedagem: restricaoHospedagem,
      idStatusRsvp: statusRsvpSelected?.value || null,
    };

    setIsloading(true);
    var formData = await updateParticipantV2(form);

    if (formData.message === "updated") {
      try {
        const { data } = await addLoginInNotificationsScheduled(
          props.idEvent,
          props?.participant?.id,
          props.state.global_user_data.data.token,
          groupsArray,
        );
        setUpdateNotification(data);

        if (checkProductExists("Distribuição de Cotas")) {
          const sessionsTransform = sessions.map((el) => ({
            id: el.id,
            eventId: props?.idEvent,
            loginId: props?.participant?.id,
            sessionId: el.sessionId,
            companionsNumber: el.companionsNumber,
            accessibilityRestriction: el.accessibilityRestriction,
            typeRestriction: el.typeRestriction,
            notes: el.notes,
            typeQuota: "manual",
            isSendEmailQuota: sendEmail,
            email: email,
            name: nome,
          }));

          await updateQuotas({
            jwt: props.state.global_user_data.data.token,
            data: sessionsTransform,
          });
        }
      } catch (error) {
        setIsloading(false);
        // console.log(error)
      } finally {
        setIsloading(false);
        setsuccess_dlg(true);
      }
    }
    setIsloading(false);
  }

  // busca os grupos do evento e popula o state de grupos
  async function getGroupsFunc() {
    try {
      const response = await getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: props.idEvent,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(response.findOneGroupData.data);
    } catch (error) {}
  }

  // verifica se um produto específico existe na configuração do evento
  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product,
      );

      if (search[0]) {
        return true;
      } else return false;
    }
    return false;
  }

  // busca as cotas do participante e popula a lista de sessões
  async function getQuotasFunc() {
    const res = await getQuotasByLogin({
      jwt: props.state.global_user_data.data.token,
      idEvent: props.idEvent,
      idLogin: props.participant.id,
    });
    if (res.message === "success") {
      const data = res.loginEventosCotas.data;
      const formattedData = data.map((e) => ({
        id: e.id,
        accessibilityRestriction: e.accessibilityrestriction,
        companionsNumber: e.companionsnumber,
        notes: e.notes,
        sessionId: e.session,
        title: `${e.title} - ${formatDate(e.startdate)} ${e.starthour}`,
        typeRestriction: e.typerestriction,
      }));
      setSessions(formattedData);
      setSessionsSource(formattedData);
    }
  }

  useEffect(() => {
    if (cpf.replace(/[^\d]+/g, "").length === 11 && !cpfValidator(cpf)) {
      setCpfError("CPF inválido");
    } else setCpfError("");
  }, [cpf]);

  useEffect(() => {
    getGroupsFunc();
    if (checkProductExists("Distribuição de Cotas")) {
      getQuotasFunc();
    }
    // Carrega lista de Status RSVP quando o produto RSVP está habilitado.
    // limit=100 é o teto aceito pelo backend. Filtra pelo contrato ativo.
    if (checkProductExists("RSVP")) {
      const contractId = props.state?.global_user_data?.data?.theme?.[0]?.id;
      if (contractId) {
        (async () => {
          const res = await getStatusRsvp({
            contractId,
            offset: 1,
            limit: 100,
            enabled: true,
          });
          if (res && Array.isArray(res.data)) {
            setStatusRsvpList(res.data);
          }
        })();
      }
    }
  }, []);

  // Quando a lista chega, pré-seleciona o Status atual do participante.
  useEffect(() => {
    if (statusRsvpList.length === 0) return;
    const eventItem = props.participant.eventos.filter(
      (e) => e.event.id === props.idEvent,
    )[0];
    const initialId =
      props.participant?.idStatusRsvp ||
      props.participant?.statusRsvp?.id ||
      eventItem?.idStatusRsvp ||
      eventItem?.statusRsvp?.id;
    if (!initialId) return;
    const found = statusRsvpList.find((s) => s.id === initialId);
    if (found) {
      setStatusRsvpSelected({ label: found.description, value: found.id });
    }
  }, [statusRsvpList]);

  useEffect(() => {
    funcGroups();
  }, [groups]);

  useEffect(() => {
    setPropsModals();
  }, [showModalNewSession, showModalEditSession, showModalDeleteSession]);

  // monta o array de grupos selecionados com base nos grupos já atribuídos ao participante
  function funcGroups() {
    var groupsArray = [];
    if (groups?.length > 0) {
      // eslint-disable-next-line array-callback-return
      props.participant.grupos.map((a) => {
        groupsArray.push({ label: a.grupo[0].name, value: a.grupo[0].id });
      });
      if (groups?.length === groupsArray.length) {
        groupsArray = [];
        groupsArray.push({ label: "TODOS", value: "todos" });
        setAllGroups(true);
      }
    }
    setGroupsMulti(groupsArray);
  }
  return (
    <>
      {checkProductExists("Distribuição de Cotas") && (
        <CompositonModals {...propsModals} />
      )}

      <Modal
        isOpen={isOpen}
        toggle={() => {}}
        autoFocus={true}
        centered={true}
      >
        {success_dlg ? (
          <SweetAlert
            success
            title={"Editado"}
            onConfirm={() => {
              props.getAllParticipants();
              toggle();
              setsuccess_dlg(false);
            }}
          >
            <>
              <p>Participante editado com sucesso!</p>
              {updateNotification && (
                <p style={{ color: "#218a64", fontStyle: "italic" }}>
                  As Notificações agendadas foram atualizadas com esse
                  participante.
                </p>
              )}
            </>
          </SweetAlert>
        ) : null}

        {sendEmail && (
          <SweetAlert
            warning
            title={"Deseja reenviar o email com os ingressos?"}
            showCancel
            confirmBtnText="Sim"
            cancelBtnText="Não"
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => {
              setSendEmail(false);
              submitForm(true);
            }}
            onCancel={() => {
              setSendEmail(false);
              submitForm(false);
            }}
          >
            Você não poderá reverter essa ação!
          </SweetAlert>
        )}

        <ModalHeader toggle={toggle}>Editar Participante</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (checkProductExists("Distribuição de Cotas")) {
                setSendEmail(true);
              } else submitForm(false);
            }}
          >
            <Row style={{ marginBottom: 10 }}>
              <Col>
                <div>
                  <label className="form-label"> ID do Participante</label>
                  <input
                    className="form-control"
                    type="text"
                    value={props?.participant?.id}
                    disabled
                  />
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Nome do Participante*</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                  {nameError && <span style={{ color: "red" }}>{nameError}</span>}
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Email do Participante*</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={email}
                    disabled
                  />
                </div>
              </Col>
            </Row>

            {showCpfAndFone() && (
                <Row style={{ marginBottom: 10 }}>
                  <Col lg={6}>
                    <div>
                      <label className="form-label">CPF</label>
                      <input
                        className="form-control"
                        value={cpf}
                        onChange={({ target }) => handleChange(target.value)}
                      />
                      {cpfError && <span style={{ color: "red" }}>{cpfError}</span>}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div>
                      <label>Telefone</label>
                      <PhoneInput
                        defaultCountry="br"
                        value={phone}
                        onChange={(phone) => setPhone(phone)}
                        countries={paisesPt}
                        inputStyle={{ width: "100%" }}
                      />
                      {foneError && <span style={{ color: "red" }}>{foneError}</span>}
                    </div>
                  </Col>
                </Row>
              )
            }

            {(checkProductExists("APP Eventos Plus") ||
              checkProductExists("Inteegra MOBI")) && (
              <>
                <Row style={{ marginBottom: 10 }}>
                  <Col lg={6}>
                    <div>
                      <label className="form-label">Título QRCode</label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={titleQrCode}
                        onChange={(e) => setTitleQrCode(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div>
                      <label className="form-label">Código QRCode</label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={codeQrCode}
                        onChange={(e) => setCodeQrCode(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                  <Col lg={12}>
                    <div>
                      <label className="form-label">
                        Informações de Acesso
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={infoAcess}
                        onChange={(e) => setInfoAccess(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                  <Col md={12}>
                    <label className="form-label">Bio do Chat</label>
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={chat}
                      onChange={(e) => setChat(e.target.value)}
                    />
                  </Col>
                </Row>
              </>
            )}

            {checkProductExists("Distribuição de Cotas") && (
              <Row style={{ marginBottom: 10 }}>
                <Col md={12}>
                  <label className="form-label" onClick={toggleSession}>
                    Sessão*
                    <i
                      className={
                        isOpenSession
                          ? "mdi mdi-arrow-up"
                          : "mdi mdi-arrow-down"
                      }
                      style={{ marginTop: 2, cursor: "pointer" }}
                    />
                  </label>
                </Col>
                <Collapse isOpen={isOpenSession}>
                  <Card
                    style={{
                      border: "0.5px solid lightgray",
                      marginBottom: "0.5px",
                    }}
                  >
                    <CardBody>
                      <Row
                        style={{
                          justifyContent: "flex-end",
                          marginRight: "5px",
                        }}
                      >
                        <Button
                          color="success"
                          className="btn-rounded waves-effect waves-light events-button-add-lg"
                          style={{ alignItems: "center", width: "auto" }}
                          onClick={() => {
                            toggleModalNewSession();
                          }}
                        >
                          Adicionar Sessão
                        </Button>
                      </Row>

                      <div style={{ marginTop: "10px" }}>
                        <Table striped className="table mb-0">
                          <thead style={{ backgroundColor: "#e4e4e4" }}>
                            <tr>
                              <th>Sessão</th>
                              <th>Quantidade de Ingressos</th>
                              <th>Restrição</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sessions &&
                              sessions
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((item) => (
                                  <tr>
                                    <td>{item.title}</td>
                                    <td>{item.companionsNumber}</td>
                                    <td>
                                      {item.accessibilityRestriction
                                        ? "Sim"
                                        : "Não"}
                                    </td>
                                    <td>
                                      <i
                                        className={"mdi mdi-pencil"}
                                        style={{
                                          color: "green",
                                          fontSize: 17,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setSessionItem(item);
                                          toggleModalEditSession();
                                        }}
                                      />
                                      <DeleteButton
                                        onClick={() => {
                                          setSessionItem(item);
                                          toggleModalDeleteSession();
                                        }}
                                        color="red"
                                        fontSize={17}
                                      />
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  {sectionError && (
                    <span style={{ color: "red" }}>{sectionError}</span>
                  )}
                </Collapse>
              </Row>
            )}

            <Row style={{ marginBottom: 10 }}>
              <Col md={6}>
                <label className="form-label">Empresa</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={company}
                  onChange={(e) => setCompany(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <label className="form-label">Cargo</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={office}
                  onChange={(e) => setOffice(e.target.value)}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col md={12}>
                <label className="form-label">Código interno 1</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={code1}
                  onChange={(e) => setCode1(e.target.value)}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col md={6}>
                <label className="form-label">Código interno 2</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={code2}
                  onChange={(e) => setCode2(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <label className="form-label">Código interno 3</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={code3}
                  onChange={(e) => setCode3(e.target.value)}
                />
              </Col>
            </Row>

            {checkProductExists("Match de Hospedagem") && (
              <Row>
                <Col md={12}>
                  <label className="form-label">Restrição de hospedagem</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={restricaoHospedagem}
                    onChange={(e) => setRestricaoHospedagem(e.target.value)}
                  />
                </Col>
              </Row>
            )}

            <Row style={{ marginTop: 10, marginBottom: 20 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Grupos</label>
                  <Select
                    value={groupsMulti}
                    placeholder={"Selecione"}
                    isMulti={true}
                    onChange={(e) => {
                      handleGroupMulti(e);
                    }}
                    noOptionsMessage={() => "Nenhuma opção encontrada"}
                    options={[
                      {
                        options:
                          groups?.length > 0 && !allGroups
                            ? [
                                { label: "TODOS", value: "todos" },
                                ...groups.map((e) => {
                                  return { label: e.name, value: e.id };
                                }),
                              ]
                            : [],
                      },
                    ]}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </Col>
            </Row>

            {checkProductExists("RSVP") && (
              <Row style={{ marginTop: 10, marginBottom: 20 }}>
                <Col md={12}>
                  <label className="form-label">Status RSVP</label>
                  <Select
                    value={statusRsvpSelected}
                    placeholder="Selecione"
                    onChange={(opt) => setStatusRsvpSelected(opt)}
                    options={statusRsvpList.map((s) => ({
                      label: s.description,
                      value: s.id,
                    }))}
                    noOptionsMessage={() => "Nenhuma opção encontrada"}
                    classNamePrefix="select2-selection"
                    isClearable
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col
                md={12}
                style={{
                  width: "100%",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  color="danger"
                  style={{ width: 80 }}
                  onClick={() => toggle()}
                >
                  Fechar
                </Button>
                <ButtonSpinner
                  isLoading={isLoading}
                  title={"Salvar"}
                  marginLeft={10}
                  action="U"
                />
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(EditParticipant);
